module.exports = __webpack_public_path__ + "1d0d4e7a415fb852dd3a6784caf2e95a.svg";